export default __webpack_public_path__ + "static/media/store_blue.d5096b3d.svg";